import { LocalDate, MilestoneBubbleType } from '../../../models';
import { BorderType } from '../../../../common';

export interface SpecialFreightMilestoneModel {
  address: string;
  bubbleType: MilestoneBubbleType;
  description: string;
  linkType: BorderType;
  plannedDateTime: LocalDate;
  title: string;
}
